<template>
  <div class="RoomActions__wrapper">
    <div class="RoomActions__container">
      <i v-if="user.isOwner"
         @click="setTitle"
         class="icon-ic_edit RoomActions__action-btn"></i>
      <i v-if="user.isOwner"
         @click="toggleAside('invite-menu')"
         :class="{'active': asideType === 'invite-menu'}"
         class="icon-ic_plus-circle RoomActions__action-btn"></i>
      <i @click="toggleAside('chat')"
         :class="{'active': asideType === 'chat'}"
         :data-count="unreadMessagesCount"
         class="icon-ic_chat RoomActions__action-btn RoomActions__chat-icon"></i>
    </div>
  </div>
</template>

<script>
  import api from '@/api';

  export default {
    name: 'RoomActions',
    props: {
      user: {
        required: true
      },
      conference: {
        required: true
      }
    },
    computed: {
      asideType() {
        return this.$store.getters.aside;
      },
      unreadMessagesCount() {
        return this.$store.getters.unreadMessagesCount;
      }
    },
    methods: {
      setTitle() {
        this.$modal.show('set-title-modal', {
          title: this.conference.status.title
        });
      },
      toggleAside(type) {
        this.$store.dispatch('toggleAside', type);
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// room-actions.vue?aa0a9b4a